import { a } from './chunk-IMSWER4T.js';

var o=class{_client=a.instance;async updateUserPreferences(e,r){return (await this._client.put(`/user-preferences/${e}`,r)).data}async updateUserNotificationPreferences(e,r){return (await this._client.put(`/user-preferences/${e}/notification`,r)).data}};

export { o as a };
//# sourceMappingURL=chunk-YYATJ2HM.js.map
//# sourceMappingURL=chunk-YYATJ2HM.js.map